import { render, staticRenderFns } from "./processCheckResult.vue?vue&type=template&id=24828a3b&scoped=true&"
import script from "./processCheckResult.vue?vue&type=script&lang=js&"
export * from "./processCheckResult.vue?vue&type=script&lang=js&"
import style0 from "./processCheckResult.vue?vue&type=style&index=0&id=24828a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24828a3b",
  null
  
)

export default component.exports